module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABPUlEQVQoU3WRzytEYRSGn/fekkxE9spqFkRRLLgmFlKyUwoL8l+QJYWFUkKxEMNyytJCyigbKVFWkh9JSdOYhTD36N5R7tzyLb6+3vd9zjlfR0SOpb0JxAjQhskFrjEO+HJWNXn8EUQVXLbdUU9FZQbDixaIvG8wf1Bj2dsSsOedgTojgSfMCkjJiHbLd65Flu6ZQmyWVTZbRjyDFmP6fAAcIXrLDNkaxh1oITbiiyzt5ZGqMbtHOgkD4gizN9DwL9AKNGP2FXQoIBLABfi7YcC4xLEcRaVw5eNrANEP9hl0OEdqi826DjwgzZXrvMv2U9OYxY2VEsBSDNiSbbRXUZO4wmiMmJfAK9D3p1ke320q7WGnK4njHCI1/LO4HBSHNHqaDYEQSnfXIWcGGEfU/n7+A7MM5s5q/Pgx0H4Aesl4H0/pqqYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/route/add.png
// module id = 8rqe
// module chunks = 2